<template>
    <b-card no-body>
        <file-manager-modal
            ref="fileManager"
            v-if="fileModalVisible"
            :modal-id="'file-manager-modal'"
            :folder-name="currentFolder ? currentFolder.FolderName : ''"
            :files="currentFiles"
            :loading="filesLoading"
            :languages="languages"
            :upload-loading="uploadLoading"
            :file-update-loading="fileUpdateLoading"
            @hidden="closeFileModal"
            @delete-file="handleDeleteFile"
            @edit-file="openEditFileModal"
            @refresh="refreshFiles"
            @upload-files="handleUploadFiles"
            @update-file="handleUpdateFile"
        />
        <b-modal id="modal-folder" :title="editingFolder ? 'Klasör Güncelle' : 'Yeni Klasör Ekle'" size="xl" no-close-on-backdrop scrollable>
            <virtual-folder-form v-if="modalVisible" v-model="editedFolder" :errors="folderErrors" :languages="languages" :parent-folders="parentFolders" />
            <template #modal-footer>
                <v-executer :loading="folderLoading" :action="saveFolder" :text="editingFolder ? 'Güncelle' : 'Oluştur'" />
            </template>
        </b-modal>

        <v-table ref="table" :fields="fields" :items-provider="provider" :add-callback="createNewFolder" :buttons="buttons" pagination="client" search title="Galeri Yönetimi">
            <template #filters>
                <b-row>
                    <b-col md="3">
                        <label>Klasör Tipi</label>
                        <v-select-list v-model="filter.FolderType" :options="folderTypes" label="label" :reduce="(item) => item.value" placeholder="Tümü" @input="$refs.table.refresh()" />
                    </b-col>
                    <b-col md="3">
                        <label>Kullanım Bağlamı</label>
                        <v-select-list v-model="filter.UsageContext" :options="usageContexts" label="label" :reduce="(item) => item.value" placeholder="Tümü" @input="$refs.table.refresh()" />
                    </b-col>
                    <b-col md="3">
                        <label>Durum</label>
                        <v-select-list
                            v-model="filter.IsActive"
                            :options="[
                                { label: 'Aktif', value: true },
                                { label: 'Pasif', value: false },
                            ]"
                            label="label"
                            :reduce="(item) => item.value"
                            placeholder="Tümü"
                            @input="$refs.table.refresh()"
                        />
                    </b-col>
                </b-row>
            </template>

            <!-- <template #cell(FolderName)="data">
                <div class="d-flex align-items-center">
                    <div class="avatar-content rounded-circle bg-light-primary p-2 mr-1">
                        <feather-icon :icon="data.item.Icon || 'FolderIcon'" size="18" class="text-primary" />
                    </div>
                    <div>
                        <div class="font-weight-bolder text-dark">{{ data.value }}</div>
                        <small class="text-muted d-block" style="font-size: 11px">{{ data.item.FolderKey }}</small>
                    </div>
                </div>
            </template> -->

            <!-- <template #cell(FolderType)="data">
                <div class="d-flex flex-column">
                    <b-badge variant="light-info" class="mb-1 w-100 text-center">{{ getLabel(folderTypes, data.value) }}</b-badge>
                    <small v-if="data.item.FolderGroup" class="text-muted text-center" style="font-size: 10px">
                        {{ data.item.FolderGroup }}
                    </small>
                </div>
            </template>

            <template #cell(UsageContext)="data">
                <b-badge variant="light-secondary">
                    {{ data.value || "Global" }}
                </b-badge>
            </template>

            <template #cell(FileCount)="data">
                <div class="d-flex align-items-center justify-content-center">
                    <feather-icon icon="FileIcon" size="14" class="mr-50 text-muted" />
                    <span class="font-weight-bold">{{ data.item.Files ? data.item.Files.length : 0 }}</span>
                </div>
            </template>

            <template #cell(IsActive)="data">
                <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
                    {{ data.value ? "Aktif" : "Pasif" }}
                </b-badge>
            </template> -->
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BModal, BBadge } from "bootstrap-vue";
import WebsiteApi from "@/api/website";
import VirtualFolderForm from "./components/VirtualFolderForm.vue";
import FileManagerModal from "./modals/FileManagerModal.vue";

export default {
    name: "GalleryManagement",
    components: {
        BCard,
        BRow,
        BCol,
        BFormInput,
        BModal,
        BBadge,
        VirtualFolderForm,
        FileManagerModal,
    },
    data() {
        return {
            folderLoading: false,
            editingFolder: false,
            modalVisible: false,
            fileModalVisible: false,
            currentFolder: null,
            currentFiles: [],
            filesLoading: false,
            uploadLoading: false,
            fileUpdateLoading: false,
            languages: [],
            parentFolders: [],
            editedFolder: this.getEmptyFolder(),
            filter: {
                FolderType: null,
                UsageContext: null,
                IsActive: null,
            },
            fields: [
                {
                    name: "Klasör",
                    key: "FolderName",
                    sortable: false,
                    tdClass: "w-20",
                    component: true,
                    componentOptions: { name: "website/TableFolderCell" },
                },
                { name: "Tip / Grup", key: "FolderType", sortable: false, tdClass: "w-20" },
                { name: "Bağlam", key: "UsageContext", sortable: false, tdClass: "w-20" },
                { name: "Kullanım Alanı", key: "UsageArea", sortable: false, tdClass: "w-15" },
                { name: "Dosyalar", key: "FileCount", sortable: false, tdClass: "w-10 text-right" },
                { name: "Sıra", key: "SortOrder", sortable: false, tdClass: "w-10 text-right" },
                { name: "Durum", key: "IsActive", sortable: false, tdClass: "w-20" },
            ],
            folderTypes: [
                { label: "Galeri", value: "gallery" },
                { label: "Slider", value: "slider" },
                { label: "Doküman", value: "document-library" },
                { label: "Video", value: "video-gallery" },
                { label: "Genel", value: "folder" },
            ],
            usageContexts: [
                { label: "Global", value: "Global" },
                { label: "İçerik", value: "Content" },
                { label: "Navigasyon", value: "Navigation" },
            ],
        };
    },
    computed: {
        buttons() {
            return [
                { text: "Dosyalar", key: "files", icon: "ImageIcon", variant: "info", action: this.openFolderContent },
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.editFolder },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteFolder },
            ];
        },
    },
    created() {
        this.loadLanguages();
        this.loadParentFolders();
    },
    methods: {
        provider(options) {
            const payload = {
                FolderType: this.filter.FolderType,
                FolderGroup: this.filter.FolderGroup,
                UsageContext: this.filter.UsageContext,
                UsageArea: this.filter.UsageArea,
                IsActive: this.filter.IsActive,
                LanguageCode: "tr",
                Skip: (options.currentPage - 1) * options.perPage,
                Take: options.perPage,
            };
            return WebsiteApi.Gallery.GetFoldersAdmin(payload);
        },

        loadLanguages() {
            WebsiteApi.Language.GetAll().then((res) => {
                if (res.data.Success) this.languages = res.data.Data;
            });
        },
        loadParentFolders() {
            WebsiteApi.Gallery.GetFoldersAdmin({ Take: 1000 }).then((res) => {
                if (res.data.Success) this.parentFolders = res.data.Data;
            });
        },

        getEmptyFolder() {
            return {
                id: null,
                folderKey: "",
                folderName: "",
                description: "",
                folderType: "gallery",
                folderGroup: "",
                parentFolderId: null,
                usageContext: "Global",
                contextEntityId: null,
                usageArea: "",
                isActive: true,
                sortOrder: 0,
                icon: "fa-folder",
                color: "#3498db",
                coverImage: "",
                maxFileCount: null,
                allowedFileTypes: "",
                translations: [],
                metaData: [],
            };
        },

        createNewFolder() {
            this.editingFolder = false;
            this.folderErrors = {};
            this.editedFolder = this.getEmptyFolder();
            this.modalVisible = true;
            this.$bvModal.show("modal-folder");
        },

        editFolder(item) {
            this.editingFolder = true;
            this.folderErrors = {};
            WebsiteApi.Gallery.GetFolderByIdAdmin(item.Id, "tr").then((res) => {
                if (res.data.Success && res.data.Data) {
                    const data = res.data.Data;
                    this.editedFolder = {
                        id: data.Id,
                        folderKey: data.FolderKey,
                        folderName: data.FolderName,
                        description: data.Description,
                        folderType: data.FolderType,
                        folderGroup: data.FolderGroup,
                        parentFolderId: data.ParentFolderId,
                        usageContext: data.UsageContext,
                        contextEntityId: data.ContextEntityId,
                        usageArea: data.UsageArea,
                        isActive: data.IsActive,
                        sortOrder: data.SortOrder,
                        icon: data.Icon,
                        color: data.Color,
                        coverImage: data.CoverImage,
                        maxFileCount: data.MaxFileCount,
                        allowedFileTypes: data.AllowedFileTypes,
                        translations: data.Translations || [],
                        metaData: data.MetaData || [],
                    };
                    this.modalVisible = true;
                    this.$bvModal.show("modal-folder");
                }
            });
        },

        saveFolder() {
            this.folderErrors = {};
            const payload = {
                FolderKey: this.editedFolder.folderKey,
                FolderName: this.editedFolder.folderName,
                Description: this.editedFolder.description,
                FolderType: this.editedFolder.folderType,
                FolderGroup: this.editedFolder.folderGroup,
                ParentFolderId: this.editedFolder.parentFolderId,
                UsageContext: this.editedFolder.usageContext,
                ContextEntityId: this.editedFolder.contextEntityId && this.editedFolder.contextEntityId.length > 30 ? this.editedFolder.contextEntityId : null,
                UsageArea: this.editedFolder.usageArea,
                IsActive: this.editedFolder.isActive,
                SortOrder: this.editedFolder.sortOrder,
                Icon: this.editedFolder.icon,
                Color: this.editedFolder.color,
                CoverImage: this.editedFolder.coverImage,
                MaxFileCount: this.editedFolder.maxFileCount,
                AllowedFileTypes: this.editedFolder.allowedFileTypes,
                Translations: this.editedFolder.translations,
                MetaData: this.editedFolder.metaData,
            };

            this.folderLoading = true;
            const apiCall = this.editingFolder ? WebsiteApi.Gallery.UpdateFolder(this.editedFolder.id, payload) : WebsiteApi.Gallery.CreateFolder(payload);

            apiCall
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                        this.loadParentFolders();
                        this.$bvModal.hide("modal-folder");
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.folderErrors = err.response.data.errors;
                    }
                    this.$result(null, err);
                })
                .finally(() => {
                    this.folderLoading = false;
                });
        },

        deleteFolder(item) {
            this.$confirm("Klasörü Sil", `"${item.FolderName}" klasörünü ve içindeki TÜM dosyaları silmek istediğinize emin misiniz?`).then((result) => {
                if (result) {
                    WebsiteApi.Gallery.DeleteFolder(item.Id).then((response) => {
                        this.$result(response);
                        if (response.data.Success) {
                            this.$refs.table.refresh();
                            this.loadParentFolders();
                        }
                    });
                }
            });
        },

        openFolderContent(item) {
            this.currentFolder = item;
            this.fileModalVisible = true;
            this.$nextTick(() => {
                this.$bvModal.show("file-manager-modal");
            });
            this.loadFiles(item.Id);
        },

        closeFileModal() {
            this.fileModalVisible = false;
            this.currentFolder = null;
            this.currentFiles = [];
            this.$refs.table.refresh();
        },

        triggerUpdateFile() {
            this.$emit("update-file", this.editingFileItem);
        },

        loadFiles(folderId) {
            this.filesLoading = true;

            const payload = {
                VirtualFolderId: folderId,
                LanguageCode: "tr",
                Skip: 0,
                Take: 1000,
            };

            WebsiteApi.Gallery.GetFilesAdmin(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.currentFiles = res.data.Data || [];
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.filesLoading = false;
                });
        },

        handleDeleteFile(file) {
            this.$confirm("Dosyayı Sil", `"${file.Title || file.FileName}" dosyasını silmek istediğinize emin misiniz?`).then((res) => {
                if (res) {
                    WebsiteApi.Gallery.DeleteFile(file.Id).then((resp) => {
                        this.$result(resp);
                        if (resp.data.Success) {
                            this.loadFiles(this.currentFolder.Id);
                        }
                    });
                }
            });
        },

        refreshFiles() {
            if (this.currentFolder) {
                this.loadFiles(this.currentFolder.Id);
            }
        },

        openEditFileModal(file) {
            console.log("Edit file:", file);
        },

        getLabel(options, value) {
            const found = options.find((o) => o.value === value);
            return found ? found.label : value;
        },
        async handleUploadFiles({ files, metadata }) {
            if (!files || files.length === 0) return;

            this.uploadLoading = true;

            try {
                const formData = WebsiteApi.Gallery.prepareUploadFormData(files, {
                    fileKey: metadata.fileKey,
                    fileType: metadata.fileType,
                    title: metadata.title,
                    alt: metadata.alt,
                    description: metadata.description,
                    sortOrder: metadata.sortOrder,
                    isActive: metadata.isActive,
                    languageCode: metadata.languageCode,
                    tags: metadata.tags,
                    translations: metadata.translations,
                });

                const response = await WebsiteApi.Gallery.UploadFiles(this.currentFolder.Id, formData);
                this.$result(response);

                if (response.data.Success) {
                    await this.loadFiles(this.currentFolder.Id);
                    if (this.$refs.fileManager) {
                        this.$refs.fileManager.onUploadSuccess();
                    }
                }
            } catch (err) {
                if (err.response && err.response.data && err.response.data.errors) {
                    this.uploadErrors = err.response.data.errors;
                }
                this.$result(null, err);
            } finally {
                this.uploadLoading = false;
            }
        },
        async handleUpdateFile(fileData) {
            const cleanData = JSON.parse(JSON.stringify(fileData));
            const fileId = cleanData.Id || cleanData.id;

            console.log("Tespit Edilen File ID:", fileId);

            if (!fileId) {
                alert("Hata: Dosya ID'si tespit edilemedi! Lütfen sayfayı yenileyip tekrar deneyin.");
                return;
            }

            this.fileUpdateLoading = true;
            const payload = {
                FileKey: cleanData.FileKey || cleanData.fileKey,
                Title: cleanData.Title || cleanData.title,
                Alt: cleanData.Alt || cleanData.alt,
                Description: cleanData.Description || cleanData.description,
                SortOrder: cleanData.SortOrder !== undefined ? cleanData.SortOrder : cleanData.sortOrder,
                IsActive: cleanData.IsActive !== undefined ? cleanData.IsActive : cleanData.isActive,
                Tags: cleanData.Tags || cleanData.tags,
                Translations: cleanData.Translations || cleanData.translations || [],
            };

            try {
                const response = await WebsiteApi.Gallery.UpdateFile(fileId, payload);
                this.$result(response);

                if (response.data.Success) {
                    if (this.currentFolder) {
                        await this.loadFiles(this.currentFolder.Id);
                    }
                    if (this.$refs.fileManager) {
                        this.$refs.fileManager.closeEditModal();
                    }
                }
            } catch (err) {
                console.error("API Hatası:", err);
                this.$result(null, err);
            } finally {
                this.fileUpdateLoading = false;
            }
        },
    },
};
</script>
